import AWS from 'aws-sdk';

const getBlob = async (fileUri) => {
    try {
        const resp = await fetch(fileUri);
        const imageBody = await resp.blob();
        return imageBody;
    } catch (err) {
        console.log(err);
    }
};


async function ups3(file) {

    const s3bucket = new AWS.S3({
        accessKeyId: 'AKIA3H66E4H3G5WBHG4X',
        secretAccessKey: '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',
        Bucket: 'filesgpx',
        signatureVersion: 'v4',
    });


    let contentType = file.type;
    let contentDeposition = 'inline;filename="' + file.name + '"';

    const fPath = file.uri;

    const img = await getBlob(fPath);

    // s3bucket.createBucket(() => {

    //     const params = {
    //         Bucket: 'filesgpx/' + file.path,
    //         Key: file.name,
    //         Body: img,
    //         ContentDisposition: contentDeposition,
    //         ContentType: contentType,
    //     };



    //     s3bucket.upload(params, (err, data) => {
    //         if (err) {
    //             console.log(err)
    //             return false;
    //         }
    //         console.log("Response URL : " + data.Location);
    //     });
    // });
};

export default ups3;